import "./divider.css";
import { Divider } from './divider';
export default Divider;